import React from "react";
import { CssVarsProvider } from "@mui/joy/styles";
import theme from "./src/theme";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  return <CssVarsProvider theme={theme}>{element}</CssVarsProvider>;
};
